import styled from 'styled-components'
// themes
import { colors } from 'themes'

export const PageContainer = styled.div`
  max-width: 800px;
  margin: 0 auto;
  padding: 24px;
`

export const PageTitle = styled.h1`
  font-size: 24px;
  font-weight: bold;
  margin-bottom: 24px;
  color: ${colors.darkBlue500};
`

export const SectionCard = styled.div`
  margin-bottom: 16px;
`

export const SectionTitle = styled.div`
  font-size: 18px;
  font-weight: bold;
  margin-bottom: 12px;
  color: ${colors.darkBlue500};
`

export const InfoText = styled.div`
  margin-bottom: 16px;
  color: ${colors.gray900};
`

export const Status = styled.div`
  font-weight: bold;
  margin-bottom: 4px;
`

export const EnabledAt = styled.span`
  font-size: 14px;
  color: ${colors.gray320};
  font-weight: normal;
`

export const StatusText = styled.span<{ enabled?: boolean }>`
  font-weight: normal;
  color: ${({ enabled }) => (enabled ? colors.green500 : colors.gray280)};
`

export const ButtonGroup = styled.div`
  margin-top: 16px;
  display: flex;
  gap: 12px;
  flex-wrap: wrap;
`
